import Component from '../abstracts/Component';
import {doAjax} from '../utils/ajaxUtil';
import {html} from 'htm/preact';
import algoliasearch from 'algoliasearch';
import {getAlgoliaResults} from '@algolia/autocomplete-preset-algolia';
import {autocomplete} from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';

export default class SearchLayerComponent extends Component {

  get SELECTORS() {
    return {
      closeBtn: '[data-close-search]',
      searchBtn: '[data-search-trigger]',
      isSaleMode: '[data-search-sale]',
      searchForm: '[data-search-form]',
      searchInput: '#search_field_box input',
      enhancedFunctions: '[data-enhanced-functions]',
      topSearchesWrapper: '[data-prefill]',
      currentLocale: '[data-search-currentLocale]',
      querySuggestionsWrapper: '#query-suggestions__wrapper',
      categorySuggestionsWrapper: '.pre-research__categories',
      algoliaSuggestionWrapper: '#pre-research__algolia',
      viewAllBtn: '#autocomplete-view-all',
      searchOverlay: '[data-search-bar-overlay]',
    };
  }

  get CONST() {
    return {
      baseUrl: 'https://query-suggestions.eu.algolia.com',
      baseUri: '/1/configs',
      indexName: '/'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.searchBtn = this.$component.querySelectorAll(this.SELECTORS.searchBtn);

    this.searchSuggestions = this.$component.querySelector(this.SELECTORS.searchSuggestions);
    this.isSaleMode = this.$component.getAttribute("data-search-sale");
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.input = this.$component.querySelector(this.SELECTORS.searchInput);
    this.searchOverlay = this.$component.querySelector(this.SELECTORS.searchOverlay);

    //
    this.searchFormUrlJs = this.searchForm.getAttribute('data-js-search-url');

    this.searchIndex = this.$component.getAttribute('data-search-index');
    this.appID = this.$component.getAttribute('data-search-appID');
    this.apiKey = this.$component.getAttribute('data-search-apiKey');
    this.analyticsApiKey = this.$component.getAttribute('data-search-analyticsApiKey');
    this.currentLocale = this.$component.getAttribute('data-search-currentLocale');
    this.enhancedFunctions = this.$component.querySelector(this.SELECTORS.enhancedFunctions);
    this.topSearchesWrapper = this.$component.querySelector(this.SELECTORS.topSearchesWrapper);
    this.querySuggestionsWrapper = this.$component.querySelector(this.SELECTORS.querySuggestionsWrapper);
    this.categorySuggestionsWrapper = this.$component.querySelector(this.SELECTORS.categorySuggestionsWrapper);
    this.algoliaSuggestionWrapper = this.$component.querySelector(this.SELECTORS.algoliaSuggestionWrapper);
    this.viewAllBtn = this.$component.querySelector(this.SELECTORS.viewAllBtn);
  }

  handleLayerOpen() {
    this.$component.classList.add("--open");
    this.input = this.$component.querySelector(this.SELECTORS.searchInput);
    if (this.input) {
      this.input.focus();
    }
    if(window.matchMedia('(min-width: 1024px)').matches) {
      this.searchOverlay.classList.remove("--hidden");
      const headerElement = document.querySelector('[data-js-component="HeaderComponent"]');
      const headerHeight = headerElement.getBoundingClientRect().height;
      this.$component.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  }

  handleLayerClose() {
    this.closeBtn?.addEventListener('click', () => {
      this.$component.classList.remove("--open");
      if(window.matchMedia('(min-width: 1024px)').matches) {
        this.searchOverlay.classList.add("--hidden");
        if(window.scrollY === 0) {
          this.$emit(this.$customEvents.HEADER_EVENTS.enableTransparent);
        }
      }
    });
  }

  handleSearchBtn() {
   this.searchBtn.forEach(trigger => {
     trigger.addEventListener("click", (event) => {
       event.preventDefault();
       this.doSearch();
     });
   });
  }

  handleInput() {
    this.input = this.$component.querySelector(this.SELECTORS.searchInput);
    if(this.input) {
      this.input.addEventListener("input", event => {
        if(event.target.value.length > 0) {
          this.closeBtn.classList.add("--hidden");
          this.searchBtn.forEach(trigger => {
            trigger.classList.remove("--hidden");
          });
        } else {
          this.closeBtn.classList.remove("--hidden");
          this.searchBtn.forEach(trigger => {
            trigger.classList.add("--hidden");
          });
          (this.categorySuggestionsWrapper || this.algoliaSuggestionWrapper)?.classList.remove('--hidden');
        }
      });
      this.input.addEventListener("focus", event => {
        this.$component.classList.add("--open");
      });
    }
  }

  getSuggestion(index, search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    //
    autocomplete({
      debug: true,
      container: '#l-s__search',
      panelContainer: '#l-s__suggestions',
      placeholder: ctx.$component.dataset.searchPlaceholder,
      detachedMediaQuery: 'none',
      getSources({query}) {
        return [
          {
            sourceId: 'querySuggestions',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: index,
                    query,
                  },
                ],
              });
            },
            getItemUrl({item}) {
              return item.url;
            },
            getItemInputValue({item}) {
              return item.query;
            },
            templates: {
              header() {
                return '';
              },
              item({item}) {
                let itemHtml;
                if (item.name === 'CARTAREGALO') {
                  itemHtml = html`
                    <div class="c-product-card small">
                      <a href="${item.link}" class="product-card__wrapper">
                        <div class="product-card__img-container">
                          <img class="product-card__img__main" src="${item.image_index}" alt=""/>
                        </div>
                        <div class="product-card__info-container product-card__info-container-name">
                          <div class="product-card__name">${item.title}</div>
                        </div>
                      </a>
                    </div>`;
                } else if ((ctx.isSaleMode || item.specialPrice) && item.sale_price !== '' && item.inSale === true) {
                  var originalPrice = item.price.toLocaleString(ctx.currentLocale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                  var salePrice = item.sale_price.toLocaleString(ctx.currentLocale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                  itemHtml = html`
                    <div class="c-product-card small">
                      <a href="${item.link}" class="product-card__wrapper">
                        <div class="product-card__img-container">
                          <img class="product-card__img__main" src="${item.image_index}" alt=""/>
                        </div>
                        <div class="product-card__info-container-name">
                          <div class="product-card__name">${item.title}</div>
                        </div>
                        <div class="product-card__info">
                          <div class="product-card__info-container-price">
                            <span class="product-card__price prices__full ${item.currency}">${originalPrice}</span>
                            <span class="product-card__price prices__discount ${item.currency}">${salePrice}</span>
                          </div>
                          <div class="product-card__info-container-detail">
                            <div class="product-card__collection">${item.collectionName}</div>
                          </div>
                        </div>
                      </a>
                    </div>`;
                } else {
                  var originalPrice = item.price.toLocaleString(ctx.currentLocale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                  itemHtml = html`
                    <div class="c-product-card small">
                      <a href="${item.link}" class="product-card__wrapper">
                        <div class="product-card__img-container">
                          <img class="product-card__img__main" src="${item.image_index}" alt=""/>
                        </div>
                        <div class="product-card__info-container-name">
                          <div class="product-card__name">${item.title}</div>
                        </div>
                        <div class="product-card__info">
                          <div class="product-card__info-container-price">
                            <span class="product-card__price prices__full ${item.currency}">${originalPrice}</span>
                          </div>
                          <div class="product-card__info-container-detail">
                            <div class="product-card__collection">${item.collectionName}</div>
                          </div>
                        </div>
                      </a>
                    </div>`;
                }
                (ctx.categorySuggestionsWrapper || ctx.algoliaSuggestionWrapper)?.classList.add('--hidden');
                ctx.viewAllBtn.classList.remove("hidden")
                return itemHtml;
              },
              footer() {
                return '';
              },
              noResults() {
                (ctx.categorySuggestionsWrapper || ctx.algoliaSuggestionWrapper)?.classList.remove('--hidden');
                ctx.viewAllBtn.classList.add("hidden")
              }
            },
          },
        ];
      },
    });
  }

  getPopularProducts() {
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    const index = searchClient.initIndex(this.searchIndex);
    const ctx = this;

    index.search('', {
      hitsPerPage: 5,
      analytics: false,
    }).then(({ hits }) => {
      const algoliaSuggestionWrapper = document.querySelectorAll('.pre-research__algolia');
      algoliaSuggestionWrapper.forEach((container) => {
        hits.forEach(product => {
          let originalPrice = product.price ? product.price.toLocaleString(ctx.currentLocale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) : '';

          let salePrice = '';
          if (product.sale_price && product.inSale === true) {
            salePrice = product.sale_price.toLocaleString(ctx.currentLocale, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          }
          if (product.name === 'CARTAREGALO') {
            container.innerHTML += `
              <div class="c-product-card small">
                <a href="${product.link}" class="product-card__wrapper">
                  <div class="product-card__img-container">
                    <img class="product-card__img__main" src="${product.image_index}" alt=""/>
                  </div>
                  <div class="product-card__info-container product-card__info-container-name">
                    <div class="product-card__name">${product.title}</div>
                  </div>
                </a>
              </div>`;
          } else if ((ctx.isSaleMode || product.specialPrice) && product.sale_price !== '' && product.inSale === true) {
            container.innerHTML += `
              <div class="c-product-card small">
                <a href="${product.link}" class="product-card__wrapper">
                  <div class="product-card__img-container">
                    <img class="product-card__img__main" src="${product.image_index}" alt=""/>
                  </div>
                  <div class="product-card__info-container-name">
                    <div class="product-card__name">${product.title}</div>
                  </div>
                  <div class="product-card__info">
                    <div class="product-card__info-container-price">
                      <span class="product-card__price prices__full ${product.currency}">${originalPrice}</span>
                      <span class="product-card__price prices__discount ${product.currency}">${salePrice}</span>
                    </div>
                    <div class="product-card__info-container-detail">
                      <div class="product-card__collection">${product.collectionName}</div>
                    </div>
                  </div>
                </a>
              </div>`;
          } else {
            container.innerHTML += `
              <div class="c-product-card small">
                <a href="${product.link}" class="product-card__wrapper">
                  <div class="product-card__img-container">
                    <img class="product-card__img__main" src="${product.image_index}" alt=""/>
                  </div>
                    <div class="product-card__info-container-name">
                      <div class="product-card__name">${product.title}</div>
                    </div>
                  <div class="product-card__info">
                    <div class="product-card__info-container-price">
                      <span class="product-card__price prices__full ${product.currency}">${originalPrice}</span>
                    </div>
                    <div class="product-card__info-container-detail">
                      <div class="product-card__collection">${product.collectionName}</div>
                    </div>
                  </div>
                </a>
              </div>`;
          }
        });
      });
    }).catch(err => {
      console.error("Error retrieving popular products", err);
    });
  }


  bindSearch() {
    const index = this.$component.dataset.searchIndex;
    this.enhancedFunctions.classList.remove('--hidden');
    this.querySuggestionsWrapper.classList.remove('--hidden');
    this.getSuggestion(index);
  }

  doSearch() {
    // get autocomplete value
    const autocompleteInput = this.input ? this.input : this.$component.querySelector(this.SELECTORS.searchInput);
    // build url
    const url = this.searchFormUrlJs + '?text=' + encodeURIComponent(autocompleteInput.value);
    // go to url
    window.location.href = url;
  }

  getTopSearches() {
    let ctx = this;
    const index = this.$component.dataset.searchIndex;
    //ctx.$component.dataset.searchEnv + '_' + ctx.$component.dataset.searchBrand.toLowerCase() + '_' + ctx.$component.dataset.searchCountry + '_' + ctx.$component.dataset.searchLanguage;
    const url = 'https://analytics.de.algolia.com/2/searches?index=' + index;
    return doAjax({
      headers: {
        'X-Algolia-API-Key': this.analyticsApiKey,
        'X-Algolia-Application-Id': this.appID,
      },
      url: url,
      dataType: "html",
      type: 'GET',
      cache: true,
      success: function (resp) {
        ctx.log('Call Successful');
        let parsedResp = JSON.parse(resp);
        const searchContainer = document.querySelectorAll('[data-searches-container]');
        try {
          for (let i = 0; i < parsedResp.searches.length; i++) {
            let searchEl = parsedResp.searches[i];
            // exclude empty searches
            if (searchEl.nbHits < 1) {
              continue;
            }
            // populate searches
            searchContainer.forEach((container) => {
              if (container.children.length < 4) {
                container.appendChild(ctx.topSearchTemplate(searchEl.search));
              }
            });
          }
        } catch (e) {
          console.warn("Algolia Top Searches response has failed.", e);
        }
      },
      error: function (xhr) {
        (ctx.categorySuggestionsWrapper || ctx.algoliaSuggestionWrapper)?.classList.add('full-width');
        ctx.querySuggestionsWrapper?.classList.add('full-width');
        ctx.topSearchesWrapper.classList.add("--hidden")
        console.log(xhr);
      }
    });
  }

  topSearchTemplate(search) {
    const searchLink = document.createElement("a");
    searchLink.classList.add("--txt-grey-dark");
    searchLink.href = "/search?text=" + encodeURIComponent(search);
    searchLink.innerHTML = search;
    return searchLink;
  }

  bindEvents() {
    //handle layer open
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.handleLayerOpen();
    });
    //handle layer close
    this.handleLayerClose();
    //handle input
    this.handleInput();
    //handle search button
    this.handleSearchBtn();
    // if suggestions are enabled, i want to keep the standard search working
    this.searchForm?.addEventListener('keypress', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.doSearch();
      }
    });
    this.searchOverlay?.addEventListener('click', () => {
      this.$component.classList.remove("--open");
      this.searchOverlay.classList.add("--hidden");
      if(window.scrollY === 0) {
        this.$emit(this.$customEvents.HEADER_EVENTS.enableTransparent);
      }
    });
  }

  render() {
    super.render();
    // if is enabled
    if (this.$component.dataset.algoliaEnabled === 'true') {
      this.getTopSearches();
      if (this.algoliaSuggestionWrapper) {
        this.getPopularProducts();
      }
      if (this.$component.dataset.searchSuggestions === 'true') {
        this.bindSearch();
      }
    }
    this.bindEvents();
  }
}
